import { z } from 'zod';
import {
    nodeCfgSchema,
} from './nodes';

export const flowConnectionSchema = z.object({
    sourceNodeId: z.string(),
    sourceNodePort: z.string(),
    targetNodeId: z.string(),
    targetNodePort: z.string(),
});
export interface FlowConnection extends z.infer<typeof flowConnectionSchema> {}

export const flowCfgSchema = z.object({
    id: z.string(),
    name: z.string(),
    nodes: z.record(nodeCfgSchema),
    connections: z.record(flowConnectionSchema),
    kind: z.union([ z.literal('regular'), z.literal('functional') ]).default('regular'),
    comments: z.record(z.object({
        id: z.string(),
        label: z.string(),
        x: z.number(),
        y: z.number(),
        nodeLink: z.string().optional(),
    })),
    groups: z.record(z.object({
        id: z.string(),
        label: z.string(),
        nodeLinks: z.array(z.string()),
    })),
}).superRefine((flowCfg, ctx) => {
    // ensure no performance node has a connection for asset id
    for (const connId in flowCfg.connections) {
        const conn = flowCfg.connections[connId]!;
        if (conn.targetNodePort === 'assetId') {
            if (flowCfg.nodes[conn.targetNodeId]?.kind === 'performanceDataCollect') {
                ctx.addIssue({
                    code: 'custom',
                    message: 'Performance Data Collect node does not support an asset ID connection',
                    fatal: true,
                });
            }
        }
    }
});
